import React from 'react';
import { Select } from 'antd';
import { DEPLOY_ENV } from "../utils/config";
import './MwsEnvironmentSelector.css';

const { Option } = Select;

interface EnvironmentSelectorProps {
    prefix: string;
    enableDevHost?: boolean;
    enableStagingHost?: boolean;
}

const MwsEnvironmentSelector: React.FC<EnvironmentSelectorProps> = ({ prefix, enableDevHost = false, enableStagingHost = true }) => {
    const onChange = (value: string) => {
        let host: string;
        if (value === 'dev'){
            host = 'mws-dev.haiskynology.com';
        }
        else if (value === 'test') {
            host = 'mws-test.haiskynology.com';
        } else if (value === 'staging') {
            host = 'mws-st.haiskynology.com';
        } else {
            host = 'mws.haiskynology.com';
        }
        if (host === window.location.host) {
            return;
        }
        window.open(`https://${prefix}.${host}${window.location.pathname}`, '_blank');
    }
    return (
        <Select value={DEPLOY_ENV} className="environment-selector" onChange={onChange}>
            {enableDevHost && <Option value="dev">dev</Option>}
            <Option value="test">test</Option>
            {enableStagingHost && <Option value="staging">staging</Option>}
            <Option value="prod">prod</Option>
        </Select>
    );
};

export default MwsEnvironmentSelector;
